import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [FaIconComponent],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  @Input() public label?: string;
  @Input() public disable = false;
  @Input('aria-label') ariaLabel?: string;
  @Input() type: 'submit' | 'button' = 'button';
  @Input() className: 'primary-button' | 'primary-form-button' = 'primary-button';
  @Input() icon?: IconDefinition;
  @Input() iconPosition: 'left' | 'right' = 'left';
  @Input() iconSize: 'xs' | 'sm' | 'lg' | 'xl' = 'sm';
  @Input() isButtonSplit = false;
  @Input() isOpenMenu = false;
  @Input() menuAriaLabel = '';
  @Output() iconClick = new EventEmitter<Event>();

  onIconClick(event: Event): void {
    event.stopPropagation();
    this.iconClick.emit(event);
  }

  get showSeparateRightButton(): boolean {
    return this.isButtonSplit;
  }
}
